// Module
var code = "<div class=\"product-photo\"> <a ng-href=\"{{ $ctrl.getLink() }}\"> <img sw-img-fallback class=\"product-photo__image order\" title=\"{{ 'core.zoom_in' | translate }}\" ng-src=\"{{ $ctrl.source }}\"/> </a> </div> ";
// Exports
export default code;